<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="产品相关">
            <el-input style="width:200px" v-model="formInline.materialNo" placeholder="产品SKU,名称" clearable />
          </el-form-item>
          <el-form-item label="上传时间">
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startMonth"
                type="date"
                placeholder="上传时间"
                clearable
            />
            -
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endMonth"
                type="date"
                placeholder="上传时间"
                clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
        >
          <el-table-column
              label="用户邮箱"
              min-width="80"
              prop="email"
          ></el-table-column>
          <el-table-column
              label="用户姓名"
              min-width="100"
              prop="name"
          ></el-table-column>
          <el-table-column
              label="产品SKU"
              min-width="100"
              prop="materSku"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="materName"
          ></el-table-column>
          <el-table-column
              label="视频封面图片"
              width="175"
              prop="img"
          >
            <template #default="scope">
              <MyImage :picture-url="scope.row.img" :picture-url-list="[scope.row.img] "></MyImage>
            </template>
          </el-table-column>
          <el-table-column
              label="视频信息"
              min-width="200"
              prop="video"
          >
            <template #default="scope">
              <div>视频大小：{{scope.row.video.fileSize}}M</div>
              <div>视频文件名：{{scope.row.video.filename}}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="视频预览"
              min-width="400"
              prop="video"
          >
            <template #default="scope">
              <vVideo
                  :options="{
                    autoplay: false,
                    controls: true,
                    sources:[
                      {
                        src: scope.row.video.path,
                        type: 'video/mp4'
                      }
                    ]
              }">
              </vVideo>
            </template>
          </el-table-column>
          <el-table-column
              label="描述"
              min-width="80"
              prop="remark"
          >

            <template #default="scope">

              <el-tooltip
                  :content="scope.row.remark"
                  :raw-content="true"
                  :show-overflow-tooltip="false"
              >
                <span class="ellipsis-fallback">
                {{scope.row.remark}}
              </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              label="上传时间"
              min-width="100"
              prop="CreateTime"
          ></el-table-column>
          <el-table-column
              label="操作"
              min-width="80"
              prop="addServices"
          >
            <template #default="scope">
              <el-button link type="primary" size="small" @click="handleClick(scope.row)">下载视频</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>

  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElInput,ElTable, ElTableColumn,ElDatePicker,ElTooltip,ElPagination} from "element-plus";
import MyImage from "@/components/myImage.vue";
import {getShopifyVideo} from "@/utils/api";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import vVideo from "@/components/video.vue";

export default {
  name: "shopifyVideo",
  mixins:[DynamicHeightMixin],
  components: {ElForm,ElFormItem,ElButton,ElInput,ElTable,MyImage,vVideo,ElDatePicker,ElTooltip,
    ElTableColumn,ElPagination},
  data(){
    return{
      formInline:{},
      tableData:[],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
    }
  },
  beforeMount() {
    this.getShopifyVideo();
  },
  methods:{
    onSubmit(){
      this.PageNumber = 1
      this.getShopifyVideo()
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getShopifyVideo();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getShopifyVideo();
    },
    getShopifyVideo(){
      this.tableData = []
      getShopifyVideo({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage}).then(res=>{
        this.tableData = res.Data.data.map((item)=>{
          return {
            ...item,
            remark:item.remark.replace(/\n/g, "<br>"),
          }
        })
        this.pageTotal = res.Data.count
      }).catch(res=>{
        console.log(res)
      })
    },
    handleClick(data){
      const link = document.createElement('a');
      link.href = data.video.path;
      link.download =data.video.filename;  // 关键属性：强制下载而非打开
      link.target = '_blank';    // 新窗口打开
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      // 清理DOM
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ellipsis-fallback {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.tooltip-class .el-tooltip__popper {
  max-width: none !important; /* 确保宽度不受限制 */
}

.tooltip-class .el-tooltip__popper .popper__arrow {
  display: none; /* 隐藏箭头，因为箭头可能会干扰布局 */
}

.tooltip-class .el-tooltip__popper .popper__inner {
  white-space: pre-wrap; /* 允许内容换行 */
  word-break: break-word; /* 在长单词或URL内部进行换行 */
}
</style>